module.exports = __webpack_public_path__ + "img/187.884c42d0.png";